export default "__VITE_ASSET__UrHzlpI3__"